import { render, staticRenderFns } from "./ParametricProjectsList.vue?vue&type=template&id=53dd1cdc"
import script from "./ParametricProjectsList.vue?vue&type=script&lang=js"
export * from "./ParametricProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ParametricProjectsList.vue?vue&type=style&index=0&id=53dd1cdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports